import React from "react";
import { Card } from "../modules/Organisations";

export function OrganisationCardPage(props) {
  return <Card {...props} />;
}
